export enum GraphicType {
    Bar,
    Line,
    Doughnut,
    Pie,
    None
}
